import { Input } from '@avanta/shared/components/ui/Input';
import { Select } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RecordFields as RecordFieldsComponent } from 'pages/AppointmentsReserve/components/ui/RecordFields';
import { useGetOptions } from 'pages/AppointmentsReserve/hooks/useGetOptions';
import {
  type AppointmentsReserveFormData,
  AppointmentsReservePayload,
} from 'pages/AppointmentsReserve/types';

export const RecordFields = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { watch, control, setValue } = useFormContext<AppointmentsReserveFormData>();
  const [contractId, contractRateId, contractAuthorization] = watch([
    AppointmentsReservePayload.contractId,
    AppointmentsReservePayload.contractRateId,
    AppointmentsReservePayload.contractAuthorization,
  ]);
  const {
    contractId: contractIdOptions,
    contractRateId: contractRateIdOptions,
    recordFields,
  } = useGetOptions();
  const requiredRecordFields = recordFields.filter(recordField => recordField.required);

  return (
    <div className="grid grid-cols-2 gap-6">
      <Select
        label={t('AppointmentsReserve.Steps.data.administrative.contract.label')}
        options={contractIdOptions ?? []}
        placeholder={t('AppointmentsReserve.Steps.data.administrative.contract.placeholder')}
        value={contractId}
        required
        readOnly
      />
      <Select
        label={t('AppointmentsReserve.Steps.data.administrative.rate.label')}
        options={contractRateIdOptions ?? []}
        placeholder={t('AppointmentsReserve.Steps.data.administrative.rate.placeholder')}
        value={contractRateId}
        required
        readOnly
      />
      <RecordFieldsComponent control={control} recordFields={requiredRecordFields} readOnly />
      <Input
        label={t('AppointmentsReserve.Steps.confirmation.contractAuthorization.label')}
        placeholder={t('AppointmentsReserve.Steps.confirmation.contractAuthorization.placeholder')}
        required
        value={contractAuthorization ?? ''}
        onChange={e => setValue(AppointmentsReservePayload.contractAuthorization, e.target.value)}
      />
    </div>
  );
};
